var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrueGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0379 11.5379C19.404 11.1718 19.404 10.5782 19.0379 10.2121C18.6718 9.84597 18.0782 9.84597 17.7121 10.2121L12.125 15.7992L10.2879 13.9621C9.9218 13.596 9.3282 13.596 8.96209 13.9621C8.59597 14.3282 8.59597 14.9218 8.96209 15.2879L11.4621 17.7879C11.8282 18.154 12.4218 18.154 12.7879 17.7879L19.0379 11.5379Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.5625C6.57867 0.5625 0.5625 6.57867 0.5625 14C0.5625 21.4213 6.57867 27.4375 14 27.4375C21.4213 27.4375 27.4375 21.4213 27.4375 14C27.4375 6.57867 21.4213 0.5625 14 0.5625ZM2.4375 14C2.4375 7.61421 7.61421 2.4375 14 2.4375C20.3858 2.4375 25.5625 7.61421 25.5625 14C25.5625 20.3858 20.3858 25.5625 14 25.5625C7.61421 25.5625 2.4375 20.3858 2.4375 14Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0379 11.5379C19.404 11.1718 19.404 10.5782 19.0379 10.2121C18.6718 9.84597 18.0782 9.84597 17.7121 10.2121L12.125 15.7992L10.2879 13.9621C9.9218 13.596 9.3282 13.596 8.96209 13.9621C8.59597 14.3282 8.59597 14.9218 8.96209 15.2879L11.4621 17.7879C11.8282 18.154 12.4218 18.154 12.7879 17.7879L19.0379 11.5379Z",
    stroke: "#828282",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.5625C6.57867 0.5625 0.5625 6.57867 0.5625 14C0.5625 21.4213 6.57867 27.4375 14 27.4375C21.4213 27.4375 27.4375 21.4213 27.4375 14C27.4375 6.57867 21.4213 0.5625 14 0.5625ZM2.4375 14C2.4375 7.61421 7.61421 2.4375 14 2.4375C20.3858 2.4375 25.5625 7.61421 25.5625 14C25.5625 20.3858 20.3858 25.5625 14 25.5625C7.61421 25.5625 2.4375 20.3858 2.4375 14Z",
    stroke: "#828282",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueGray);
export default __webpack_public_path__ + "static/media/true_gray.4f3796adceca9b053e20b605632446ec.svg";
export { ForwardRef as ReactComponent };